class CookieManagement {

    static instance;

    constructor() {

        if (!CookieManagement.instance) {
            CookieManagement.instance = this;
        }
        return CookieManagement.instance;
    }

     createCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/; domain=" + window.location.hostname;
    }


    deleteCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }


     loadGoogleAnalyticsScript() {
        console.log("Load Analythics");
        var script = document.createElement('script');
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-JG39DRZW3C';
        script.async = true;
        document.head.appendChild(script);

        script.onload = ()=> {
            this.initializeGoogleAnalytics();
        };
    }

     initializeGoogleAnalytics() {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-JG39DRZW3C');
    }


    setCookiePreferences() {
        console.log("Cookie Preferences made");
        this.createCookie('allowCookieStats', $("#cookie-stats").is(":checked"), 365);
        this.createCookie('allowCookieMarketing', $("#cookie-marketing").is(":checked"), 365);
        this.createCookie('allowCookieComfort', $("#cookie-comfort").is(":checked"), 365);

        if ($("#cookie-marketing").is(":checked")) {
            console.log("Marketing active");
            /* jshint ignore:start */
            // Your Facebook Pixel code here
            /* jshint ignore:end */
        } else {
            this.deleteCookie("_fbp");
            this.deleteCookie("fr");
        }

        if ($("#cookie-stats").is(":checked")) {
            console.log("Statistics active");
            this.loadGoogleAnalyticsScript();
        }

        $(".js-cookie-notice, .cookie-consent").fadeOut(500);
    }

    setSelectedCookies() {
        console.log("Set Selected Cookie Preferences made");
        this.setCookiePreferences();
    }

    setAllCookies() {
        console.log("Set All Cookie Preferences made");
        $(".cookie-popup .ody-checkbox").prop('checked', true);
        this.setCookiePreferences();
    }

    showCookieSettings() {
        $(".js-cookie-notice, .cookie-consent").show();
    }

    bindEvents() {
        $(document).on("click", ".js-set-selected-cookies", (e) => {
            e.preventDefault();
            this.setSelectedCookies();
        });

        $(document).on("click", ".js-set-all-cookies", (e) => {
            e.preventDefault();
            this.setAllCookies();
        });

        $(document).on("click", ".cookie-settings", (e) => {
            e.preventDefault();
            this.showCookieSettings();
        });
    }
}

export default CookieManagement;
